import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { AvatarWithLabel, Box, Button, ScrollArea, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { ApprovalCheckError } from './ApprovalCheckError';
import { useApprovalCheck } from './ApprovalCheckProvider';
import { RequiredApproverCard } from './RequiredApproverCard';
import { RerunCheckButton } from './RerunCheckButton';
import { SelectVoluntaryApprovers } from './SelectVoluntaryApprovers';
import { ActionsFooter, Content, Container, InnerContent } from './styled';
export function ReviewState() {
    const { response, resetCheck } = useApprovalCheck();
    const { summary, isApprovalRequired, approvers } = response;
    const handleCancel = () => {
        resetCheck();
    };
    return (<Container>
      <Content>
        <ScrollArea>
          <InnerContent>
            <ApprovalCheckError />

            <Box flexDirection="column" gap="md">
              <AvatarWithLabel solid size="sm" appearance="dark" title={t({ message: 'PLAI', comment: 'Document approval check - PLAI' })}>
                <Falcon icon="sparkles"/>
              </AvatarWithLabel>
              <Typography $fontSize="small" $appearance="300">
                {summary}
              </Typography>
            </Box>

            {isApprovalRequired && (<Box flexDirection="column" gap="md">
                <Box alignItems="center" gap="md">
                  <Falcon icon="eye" $color="gray.800"/>
                  <Typography $fontSize="tiny" $appearance="200">
                    <Trans comment="Document approval check - Approval required by">Approval required by</Trans>
                  </Typography>
                </Box>
                {approvers.map((approver) => (<RequiredApproverCard key={approver.id} {...approver}/>))}
              </Box>)}
          </InnerContent>
        </ScrollArea>
      </Content>

      <ActionsFooter>
        <Box flexDirection="column" gap="md">
          <SelectVoluntaryApprovers />
          <Box gap="md">
            <Button $stretch appearance="secondary" size="small" onClick={handleCancel}>
              <Trans comment="Document approval check - Cancel button label">Cancel</Trans>
            </Button>
            <RerunCheckButton />
          </Box>
        </Box>
      </ActionsFooter>
    </Container>);
}
